import React from "react";

import { getresultOne } from "../../redux/home/action";
import { useSelector, useDispatch } from "react-redux";

// Import Highcharts
import Highcharts from "highcharts/highstock";
import sunburst from "highcharts/modules/sunburst.js";
//import HighchartsReact from "./HighchartsReact.js";
import HighchartsReact from "highcharts-react-official";

sunburst(Highcharts);

export default function SunburstChart(props) {
  //   const { data } = props;
  const { page, university, knowledge, impact, goal } = props;
  const dispatch = useDispatch();

  const DataChart = useSelector((state) => state.statehome.knowledgeChart);
  const innovationsResult = useSelector(
    (state) => state.statehome.innovationsResult
  );
  const newknowledgeResult = useSelector(
    (state) => state.statehome.newknowledgeResult
  );
  const knowledgeResult = useSelector(
    (state) => state.statehome.knowledgeResult
  );
  console.log(
    "api :",
    university,
    ":",
    knowledge,
    ":",
    impact,
    ":",
    goal,
    ":",
    page,
    ":"
  );
  console.log("knowledgeResult222:", knowledgeResult);
  console.log("newknowledgeResult222:", newknowledgeResult);
  console.log("innovationsResult222:", innovationsResult);

  console.log("chartType:", page);
  console.log("dataChart2222:", DataChart);
  const getdata = async (e) => {
    console.log("Chart node", e.point.node);
    let level = e.point.node.level;
    console.log("Chart level", level);

    if (level === 1) {
      dispatch(
        getresultOne(
          university ? university : "",
          knowledge ? knowledge : "",
          impact ? impact : "",
          goal ? goal : "",
          page,
          "",
          ""
        )
      );
      console.log("Chart if 1 true");
    } else if (level === 2) {
      if (typeof e.point.node.sliced != "undefined") {
        dispatch(
          getresultOne(
            university ? university : "",
            knowledge ? knowledge : "",
            impact ? impact : "",
            goal ? goal : "",
            page,
            e.point.node.name,
            ""
          )
        );
        console.log("Chart if true");
      } else {
        dispatch(
          getresultOne(
            university ? university : "",
            knowledge ? knowledge : "",
            impact ? impact : "",
            goal ? goal : "",
            page,
            "",
            ""
          )
        );
        console.log("Chart if false");
      }
    } else if (level === 3) {
      let id = e.point.node.id;
      const myArray = id.split(".");
      console.log("id ", myArray[0]);
      dispatch(
        getresultOne(
          university ? university : "",
          knowledge ? knowledge : "",
          impact ? impact : "",
          goal ? goal : "",
          page,
          myArray[0],
          myArray[1]
        )
      );
    }
  };

  const options = {
    chart: {
      height: "100%",
    },
    colors: ["transparent"].concat(Highcharts.getOptions().colors),
    title: {
      text: "   ",
    },
    series: [
      {
        type: "sunburst",
        allowDrillToNode: true,
        breadcrumbs: {
          showFullPath: false,
        },
        data: DataChart,
        cursor: "pointer",
        point: {
          events: {
            click: (e) => {
              getdata(e);
            },
          },
        },
        custom: {
          percentage: "whole", //'whole' or 'parent'
        },
        dataLabels: {
          format: "{point.name}",
          filter: {
            property: "innerArcLength",
            operator: ">",
            value: 16,
          },
          rotationMode: "circular",
        },
        levels: [
          {
            level: 1,
            levelIsConstant: false,
            dataLabels: {
              filter: {
                property: "outerArcLength",
                operator: ">",
                value: 64,
              },
            },
          },
          {
            level: 2,
            colorByPoint: true,
          },
          {
            level: 3,
            colorVariation: {
              key: "brightness",
              to: -0.3,
            },
          },
        ],
      },
    ],

    tooltip: {
      headerFormat: "",
      pointFormat: "<b>{point.name}</b> คือ <b>{point.value}</b>",
    },
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
